import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { type AuditEventListParams, activityApi } from '@/services/activity.service'

/**
 * The Administration audit log.
 *
 * Short `staleTime`, like the webhook ledger: this page answers "what happened",
 * so a stale page is worse than an extra fetch. Read-only, so there is no
 * mutation and nothing to invalidate.
 */
const AUDIT_EVENTS_KEY = ['admin-audit-events'] as const

export const useAuditEvents = (params: AuditEventListParams) =>
	useQuery({
		// The params are part of the key so paging and filtering each get their own
		// cache entry, and going back a page is instant rather than a refetch.
		queryKey: [...AUDIT_EVENTS_KEY, params],
		queryFn: () => activityApi.listAudit(params),
		// Hold the previous page while the next one loads. Without it the envelope is
		// undefined for the new key, the total reads as 0, and the pager unmounts
		// itself mid-click - the control you just pressed disappears under the cursor.
		placeholderData: keepPreviousData,
		staleTime: 10_000,
	})
